// extracted by mini-css-extract-plugin
export default {"OrderCloseForm":"OrderCloseForm_OrderCloseForm__o7tH2"};